import http from "../http-common";

class FaxDataService {
  getAll() {
    return http.get("/faxes");
  }
}

export default new FaxDataService();